import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { tripsApi, type CreateTripInput } from '@/api/trips';

const POLL_MS = 30_000;

export function useMyTrips() {
  return useQuery({
    queryKey: ['trips', 'my'],
    queryFn: () => tripsApi.listMy(),
    refetchInterval: POLL_MS,
    refetchIntervalInBackground: false,
  });
}

export function useTrip(id: number | null) {
  return useQuery({
    queryKey: ['trips', 'detail', id],
    queryFn: () => tripsApi.findById(id!),
    enabled: id != null,
    refetchInterval: POLL_MS,
    refetchIntervalInBackground: false,
  });
}

export function useCreateTrip() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateTripInput) => tripsApi.create(input),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['trips', 'my'] }); },
  });
}

export function useCancelTrip() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => tripsApi.cancel(id),
    onSuccess: (_d, id) => {
      void qc.invalidateQueries({ queryKey: ['trips', 'my'] });
      void qc.invalidateQueries({ queryKey: ['trips', 'detail', id] });
    },
  });
}
